import React from 'react';
import { useHistory } from 'react-router-dom'; 
import { Dialog, DialogTitle, DialogContent, TextField, Button, DialogActions, Box, Typography } from '@mui/material';
import { useState } from 'react';
import axios from 'axios';

function Photos() {
    const history = useHistory(); 

    const [open, setOpen] = useState(false);
    const [image, setImage] = useState(null);
    const [description, setDescription] = useState('');

    const handleFileChange = (e) => {
        setImage(e.target.files[0]);
    };

    const handlePost = async () => {
        if (!image) return alert("Select a photo first");

        const formData = new FormData();
        formData.append("image", image);
        formData.append("description", description);

        try {
            await axios.post('/photos/postPhotos', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true  
            });
            setOpen(false);
            setImage(null);
            setDescription('');
            alert("Photo posted!");
        } catch (err) {
            console.error(err);
            alert("Upload failed");
        }
    };

    return (
        <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
            {/*<Button variant="contained" onClick={() => history.push('/photos/popularPhotos')}>
            Popular
            </Button>*/}
            <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/photos/popularPhotos')}
                    >
                        Popular
                    </Button>
            {/*<Button variant="contained" onClick={() => history.push('/photos/followingPhotos')}>
            Following
            </Button>*/}
            <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/photos/followingPhotos')}
                    >
                        Following
                    </Button>
            {/*<Button variant="contained" onClick={() => history.push('/photos/recommendedPhotos')}>
            Recommended
            </Button>*/}
            <>
                {/*<Button onClick={() => setOpen(true)} variant="contained">Post Photo</Button>*/}
                <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => setOpen(true)}
                    >
                        Post Photo
                    </Button>
                <Dialog open={open} onClose={() => setOpen(false)}>
                    <DialogTitle>Post a Photo</DialogTitle>
                    <DialogContent>
                    <input type="file" accept="image/*" onChange={handleFileChange} />
                    <TextField
                        fullWidth
                        multiline
                        rows={2}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Write a description"
                        margin="normal"
                    />
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button onClick={handlePost} variant="contained">Post</Button>
                    </DialogActions>
                </Dialog>
            </>
            </Box>
        </div>
    );
}

export default Photos;
